module.exports = __webpack_public_path__ + "static/logo.0fb4f59e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 152
// module chunks = 35783957827783 127739730903958